export default "__VITE_ASSET__B2yRDO0r__"